import {Component} from '@angular/core';

@Component({
  selector: 'icon-trash',
  imports: [],
  standalone: true,
  templateUrl: './icon-trash.component.html'
})
export class IconTrashComponent {

}
